'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.KAR = exports.STO = exports.FAK = exports.DOB = exports.POK = exports.BAN = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:22:50Z                      #

// ##############################################################

/**
 * Typ dokladu pro platby.
 */

/**
 * Bankovní doklad.
 */
var BAN = exports.BAN = 'BAN';

/**
 * Pokladní doklad.
 */
var POK = exports.POK = 'POK';

/**
 * Dobropis.
 */
var DOB = exports.DOB = 'DOB';

/**
 * Faktura.
 */
var FAK = exports.FAK = 'FAK';

/**
 * Storno doklad.
 */
var STO = exports.STO = 'STO';

/**
 * Karta.
 */
var KAR = exports.KAR = 'KAR';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [BAN, POK, DOB, FAK, STO, KAR];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, BAN, { caption: 'Bankovní doklad.' }), (0, _defineProperty3.default)(_params, POK, { caption: 'Pokladní doklad.' }), (0, _defineProperty3.default)(_params, DOB, { caption: 'Dobropis.' }), (0, _defineProperty3.default)(_params, FAK, { caption: 'Faktura.' }), (0, _defineProperty3.default)(_params, STO, { caption: 'Storno doklad.' }), (0, _defineProperty3.default)(_params, KAR, { caption: 'Karta.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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